import { parsePageParams } from "@/lib/paging";

export function sitePageSize(value?: number): number {
  return parsePageParams({ get: key => key === "limit" && value !== undefined ? String(value) : null }, { defaultLimit: 20 }).limit;
}

export function parseListPage(raw: string | undefined): number | null {
  if (raw === undefined || raw === "") {
    return 1;
  }

  return /^[1-9]\d{0,5}$/.test(raw) ? Number(raw) : null;
}

export function pageHref(base: string, page: number): string {
  const url = new URL(base, "http://placeholder");
  if (page > 1) {
    url.searchParams.set("page", String(page));
  } else {
    url.searchParams.delete("page");
  }

  return `${url.pathname}${url.search}`;
}

export function pagerItems(page: number, totalPages: number): Array<number | "gap"> {
  const shown = new Set([1, totalPages]);
  for (let item = page - 2; item <= page + 2; item += 1) {
    if (item >= 1 && item <= totalPages) {
      shown.add(item);
    }
  }

  const items: Array<number | "gap"> = [];
  let previous = 0;
  for (const item of [...shown].sort((a, b) => a - b)) {
    if (item - previous === 2) {
      items.push(item - 1);
    } else if (item - previous > 2) {
      items.push("gap");
    }
    items.push(item);
    previous = item;
  }

  return items;
}
